import axios from '@/http/axios/index.js'

export default {
    getAttachments(payload) {
        return axios.get('expenses/get-attachments', { params: payload })
    },
    uploadAttachment(data) {
        return axios.post('expenses/attachment/upload', data, {
            headers: { 'Content-Type': 'multipart/form-data' },
            processData: false,
            contentType: false
        })
    },
     downloadAttachment(payload) {
        return axios.get('expenses/attachment/download', { params: payload, responseType: 'blob'})
    },
}